// REEMPLAZA TODO EL CONTENIDO DE assets/component-tabs.js

class ProductTabSystem {
  constructor(container) {
    this.container = container;
    this.tabList = container.querySelector('[role="tablist"]');
    this.tabs = container.querySelectorAll('[role="tab"]');
    this.panels = container.querySelectorAll('[role="tabpanel"]');
    this.currentTab = 0;
    this.isMobile = window.innerWidth <= 749;
    this.mobileButtons = [];
    
    if (this.tabs.length > 0) {
      this.init();
    }
  }

  init() {
    if (this.isMobile) {
      this.setupMobileAccordion();
    } else {
      this.setupDesktopTabs();
    }
    this.bindEvents();
    this.applyStyles();
  }

  setupMobileAccordion() {
    // Limpiar botones móviles existentes
    this.mobileButtons.forEach(btn => btn.remove());
    this.mobileButtons = [];
    
    // Crear botones de acordeón para cada panel
    this.panels.forEach((panel, index) => {
      const tabTitle = this.tabs[index] ? this.tabs[index].textContent.trim() : `Tab ${index + 1}`;
      
      // Crear botón de acordeón
      const accordionButton = document.createElement('button');
      accordionButton.className = 'mobile-accordion-button';
      accordionButton.innerHTML = `
        <span class="accordion-title">${tabTitle}</span>
        <span class="accordion-icon">+</span>
      `;
      
      // Insertar botón antes del panel
      panel.parentNode.insertBefore(accordionButton, panel);
      this.mobileButtons.push(accordionButton);
      
      // Event listener para acordeón
      accordionButton.addEventListener('click', () => {
        this.toggleMobilePanel(index);
      });
      
      // Asegurar que todos los paneles estén visibles pero con contenido oculto
      panel.hidden = false;
      panel.style.position = 'relative';
      panel.style.opacity = '1';
      panel.style.transform = 'none';
      
      const content = panel.querySelector('.product-tab-content');
      if (content) {
        content.style.display = 'none';
      }
    });
  }

  setupDesktopTabs() {
    // Limpiar botones móviles si existen
    this.mobileButtons.forEach(btn => btn.remove());
    this.mobileButtons = [];
    
    // Configuración normal de desktop
    this.setActiveTab(0);
  }

  toggleMobilePanel(index) {
    const panel = this.panels[index];
    const button = this.mobileButtons[index];
    const content = panel.querySelector('.product-tab-content');
    const icon = button.querySelector('.accordion-icon');
    
    const isCurrentlyActive = panel.classList.contains('mobile-active');
    
    // Cerrar todos los paneles primero
    this.panels.forEach((p, i) => {
      p.classList.remove('mobile-active');
      const pContent = p.querySelector('.product-tab-content');
      if (pContent) {
        pContent.style.display = 'none';
      }
    });
    
    // Resetear todos los iconos
    this.mobileButtons.forEach(btn => {
      const btnIcon = btn.querySelector('.accordion-icon');
      if (btnIcon) {
        btnIcon.textContent = '+';
      }
    });
    
    // Si no estaba activo, activarlo
    if (!isCurrentlyActive) {
      panel.classList.add('mobile-active');
      if (content) {
        content.style.display = 'block';
      }
      if (icon) {
        icon.textContent = '−';
      }
      
      console.log(`Abriendo panel ${index}:`, content); // Debug
    }
  }

  bindEvents() {
    if (!this.isMobile) {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          this.setActiveTab(index);
        });
        
        tab.addEventListener('keydown', (e) => {
          this.handleKeydown(e, index);
        });
      });
    }

    // Handle window resize
    window.addEventListener('resize', () => {
      const newIsMobile = window.innerWidth <= 749;
      if (newIsMobile !== this.isMobile) {
        this.isMobile = newIsMobile;
        // Reinicializar en lugar de recargar
        this.init();
      }
    });
  }

  handleKeydown(event, index) {
    if (this.isMobile) return;
    
    let newIndex = index;
    
    switch(event.key) {
      case 'ArrowRight':
        newIndex = (index + 1) % this.tabs.length;
        break;
      case 'ArrowLeft':
        newIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        break;
      case 'Home':
        newIndex = 0;
        break;
      case 'End':
        newIndex = this.tabs.length - 1;
        break;
      case 'Enter':
      case ' ':
        this.setActiveTab(index);
        return;
      default:
        return;
    }
    
    event.preventDefault();
    this.tabs[newIndex].focus();
    this.setActiveTab(newIndex);
  }

  setActiveTab(index) {
    if (this.isMobile) return; // No usar en móvil
    if (index < 0 || index >= this.tabs.length) return;

    // Update tabs
    this.tabs.forEach((tab, i) => {
      const isActive = i === index;
      tab.setAttribute('aria-selected', isActive);
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    // Update panels para desktop
    this.panels.forEach((panel, i) => {
      const isActive = i === index;
      
      if (isActive) {
        panel.hidden = false;
        panel.offsetHeight;
      } else {
        panel.hidden = true;
      }
    });

    this.currentTab = index;
    this.scrollTabIntoView(index);
    
    this.container.dispatchEvent(new CustomEvent('tabchange', {
      detail: { 
        activeIndex: index, 
        activeTab: this.tabs[index],
        activePanel: this.panels[index]
      }
    }));
  }

  scrollTabIntoView(index) {
    if (this.isMobile) return;
    
    const activeTab = this.tabs[index];
    const tabList = this.tabList;
    
    if (activeTab && tabList && tabList.scrollWidth > tabList.clientWidth) {
      activeTab.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  }

  applyStyles() {
    const style = this.container.dataset.style;
    const accentColor = this.container.dataset.accentColor;
    const borderRadius = this.container.dataset.borderRadius;
    
    if (style) {
      this.container.setAttribute('data-style', style);
    }
    
    if (accentColor) {
      this.container.style.setProperty('--tab-accent-color', accentColor);
    }
    
    if (borderRadius) {
      this.container.style.setProperty('--border-radius', borderRadius + 'px');
    }
  }

  goToTab(index) {
    if (this.isMobile) {
      this.toggleMobilePanel(index);
    } else if (index >= 0 && index < this.tabs.length) {
      this.setActiveTab(index);
      this.tabs[index].focus();
    }
  }

  getCurrentTab() {
    return {
      index: this.currentTab,
      tab: this.tabs[this.currentTab],
      panel: this.panels[this.currentTab]
    };
  }
}

// Initialize all tab systems when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const tabSystems = document.querySelectorAll('[data-tab-system]');
  tabSystems.forEach(container => {
    new ProductTabSystem(container);
  });
});

// Re-initialize if content is dynamically loaded
document.addEventListener('shopify:section:load', (event) => {
  const tabSystems = event.target.querySelectorAll('[data-tab-system]');
  tabSystems.forEach(container => {
    new ProductTabSystem(container);
  });
});

// Debug: log cuando se inicializa
console.log('Product Tab System loaded');